// extracted by mini-css-extract-plugin
module.exports = {"button":"index-module_button_giqLC"};